module.exports = __webpack_public_path__ + "kit_1_header.jpg?dab8f85a72f7f14cc5cbe6f775be9fed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kit_1_header.jpg
// module id = 432
// module chunks = 0